import { render, staticRenderFns } from "./EvaluationRules.vue?vue&type=template&id=5ef40d0b&scoped=true&"
import script from "./EvaluationRules.vue?vue&type=script&lang=ts&"
export * from "./EvaluationRules.vue?vue&type=script&lang=ts&"
import style0 from "./EvaluationRules.vue?vue&type=style&index=0&id=5ef40d0b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef40d0b",
  null
  
)

export default component.exports